import { atom } from 'jotai'

// 存储一下 interim 获取的 schoolId，确保能实时获取 schoolId
export const interimSchoolIdAtom = atom<number | undefined>(undefined)
